import { SAVE_CONTRACTS } from './actionTypes'
import { ContractsModel } from '../../../types/contracts/contractsModel'
import { ContractsType } from './types'

export const saveContracts = (contracts: Partial<ContractsModel>[]): ContractsType => {
	return ({
		type: SAVE_CONTRACTS,
		payload: contracts
	})
}
